import React, { useState, useEffect } from "react";
import '../../index.css';

const initialSessions = [
  { id: 1, name: "2021-2022", from: "2021-04-01", to: "2022-03-31", status: "Inactive" },
  { id: 2, name: "2022-2023", from: "2022-04-01", to: "2023-03-31", status: "Inactive" },
  { id: 3, name: "2023-2024", from: "2023-04-01", to: "2024-03-31", status: "Active" },
  { id: 4, name: "2024-2025", from: "2024-04-01", to: "2025-03-31", status: "Active" },
];

export default function Session() {

  const STORAGE_KEY = "sessions";
  const [sessionList, setSessionList] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    from: "",
    to: "",
    status: "formData.status"
  });

  //  FILTER
  const filteredSessions = sessionList.filter((s) =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
    new Date(s.from).toLocaleDateString("en-GB").includes(searchTerm) ||
    new Date(s.to).toLocaleDateString("en-GB").includes(searchTerm)
  );

  // AUTO NAME
  const generateSessionName = (from) => {
    if (!from) return "";
    const year = new Date(from).getFullYear();
    return `${year}-${year + 1}`;
  };

  // ADD
  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      name: "",
      from: "",
      to: "",
      status: "Inactive"
    });
    setShowModal(true);
  };

  // UPDATE
  const openEditModal = () => {
    if (!selectedSession) {
      alert("Select a session first");
      return;
    }
    setIsEdit(true);
    setFormData(selectedSession);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selectedSession) {
      alert("Select a session first");
      return;
    }

    const updated = sessionList.filter(
      (s) => s.id !== selectedSession.id
    );

    setSessionList(updated);

    //  Save
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("storage"));

    setSelectedSession(null);
  };

  // SAVE
  const handleSave = () => {

    if (!formData.name || !formData.from || !formData.to) {
      alert("All fields required");
      return;
    }

    if (new Date(formData.to) <= new Date(formData.from)) {
      alert("End date must be greater than Start date");
      return;
    }

    let updatedList = [];

    if (isEdit) {
      updatedList = sessionList.map((s) =>
        s.id === formData.id ? formData : s
      );
    } else {
      updatedList = sessionList.map((s) => ({
        ...s,
        status: "Inactive"
      }));

      const newSession = {
        ...formData,
        id: Date.now(),
        status: "Active"
      };

      updatedList = [newSession, ...updatedList];
    }

    setSessionList(updatedList);

    //  SAVE to localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));

    // Sync across tabs
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelectedSession(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialSessions));
      setSessionList(initialSessions);
    } else {
      setSessionList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setSessionList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);


  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .status { color:green; }

        input[type="checkbox"] {
          cursor:pointer;
        }

        /* MODAL */
        .modal {
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

       .modal-content input,
.modal-content select {
  width:100%;
  margin-bottom:10px;
  padding:8px;
}
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>Session</h3>
            <div>{sessionList.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">

            <input
              className="search-box"
              placeholder="Search by session, status, date..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAddModal}>
              + Add Session
            </button>

            <button className="btn btn-blue" onClick={openEditModal}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Session</th>
                <th>From</th>
                <th>To</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredSessions.map((s) => (
                <tr
                  key={s.id}
                  className={selectedSession?.id === s.id ? "active-row" : ""}
                  onClick={() =>
                    setSelectedSession(
                      selectedSession?.id === s.id ? null : s
                    )
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedSession?.id === s.id}
                      onChange={() =>
                        setSelectedSession(
                          selectedSession?.id === s.id ? null : s
                        )
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{s.name}</td>
                  <td>{new Date(s.from).toLocaleDateString("en-GB")}</td>
                  <td>{new Date(s.to).toLocaleDateString("en-GB")}</td>
                  <td className="status">{s.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update Session" : "Add Session"}</h3>

              <input
                placeholder="Session Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <input
                type="date"
                value={formData.from}
                onChange={(e) => {
                  const from = e.target.value;
                  setFormData({
                    ...formData,
                    from,
                    name: generateSessionName(from),
                  });
                }}
              />

              <input
                type="date"
                value={formData.to}
                onChange={(e) =>
                  setFormData({ ...formData, to: e.target.value })
                }
              />

              <select
                value={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.value })
                }
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>
                  Save
                </button>

                <button
                  className="btn btn-red"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}